module.exports = __webpack_public_path__ + "img/dsci0124.871c75cd.jpg";